var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DamageClaim',{attrs:{"claim":_vm.claim,"classification_style":_vm.classification_style,"participant_type":_vm.participant.type}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }